<template>
    <div>
        <header>
            <span class="new-headline-xlg text-centered">Wir freuen uns, wenn Sie uns noch verraten, wie Sie auf Vitadio aufmerksam geworden sind.</span>
        </header>

        <div class="form-input-radio-button-wrapper">
            <form-input-type-radio-button
                v-for="(item, index) in survey"
                :key="index"
                :value="item"
                @onClick="chooseSurvey(item)"
                isSending
            ></form-input-type-radio-button>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                choosenSurvey: null,
                survey: [
                    'Hausarzt oder Hausärztin',
                    'Diabetologe oder Diabetologin',
                    'Medizinisches Fachpersonal',
                    'Social Media',
                    'Familie oder Freunde',
                    'Presse',
                    'Internet-Recherche',
                    'Anderes'
                ],
            }
        },

        watch: {
        },

        methods: {
            chooseSurvey(learnt_about_vitadio_from) {
                this.choosenSurvey = learnt_about_vitadio_from

                this.submit()
            },

            submit() {
                var formData = {}
                let gaCookie = window.getCookie("_ga")
                let ga_client_id = null

                if(gaCookie !== "" && gaCookie !== "undefined") {
                    ga_client_id = gaCookie
                }

                formData.ga_client_id = ga_client_id
                formData.value = this.choosenSurvey
                
                axios
                    .post('/api/learnt-about-vitadio-from', formData, {
                        headers: {
                            'Accept-Language': 'de'
                        }
                    })
                    .then((e) => {
                        setTimeout(() => {
                            Vuemit.fire('Learnt-about-vitadio--set', this.choosenSurvey)
                            this.$emit('clicked', 'success')
                        }, 250);
                    })
                    .catch((e) => {
                        this.errors = e.response.data.errors
                        console.log(e.response)
                        Vuemit.fire('Button--sending-failed', true)
                    })
            }
        }
    }
</script>